import { Store } from 'vuex';
import { ProffAdminApi, ProffApi } from '@/../gen';
import { RootState } from '@/store';
import * as requestInterceptor from '@/store/plugins/api/interceptors/requestInterceptor';
import * as responseInterceptor from '@/store/plugins/api/interceptors/responseInterceptor';
import { initAxios } from '@/store/plugins/api/axios';
import * as UiStore from '@/store/modules/ui';

export default () => {
  return (store: Store<RootState>) => {
    const axios = initAxios();

    // progress
    const enableProgress = () =>
      store.dispatch(UiStore.SetIsLoading.namespaced({ isLoading: true }));
    const disableProgress = () =>
      store.dispatch(UiStore.SetIsLoading.namespaced({ isLoading: false }));

    // interceptors
    axios.interceptors.request.use(
      requestInterceptor.initOnFullFilled(store, enableProgress)
    );
    axios.interceptors.response.use(
      responseInterceptor.initOnFullFilled(store, disableProgress),
      responseInterceptor.initOnRejected(store, disableProgress)
    );

    // extend store
    store.proffApi = new ProffApi({ basePath: '' }, '', axios);
    store.proffAdminApi = new ProffAdminApi({ basePath: '' }, '', axios);
  };
};
